<template>
  <div id="txtContainer" ref="txtContainer" v-loading="loadingActive" element-loading-text="拼命加载中">
    <iframe :src="urlSrc"></iframe>
  </div>
</template>

<script>
import { scanUrl } from "@/CommonDP/utils";
export default {
  data() {
    return {
      loadingActive: true,
      urlSrc: ""
    };
  },

  async mounted() {
    const { f, n } = this.$route.query;
    document.title = n;
    this.urlSrc = scanUrl(f, "");
    this.loadingActive = false;
  },

  methods: {}
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#txtContainer {
  width: 100%;
  height: 100%;

  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
